import _ from 'ckLodash';

function createWixStyleElement(editor, id, css) {
    var elem = new CKEDITOR.dom.element('style', editor.document);
    elem.setAttribute('id', id);
    elem.setAttribute('type', 'text/css');
    elem.appendText(css);
    return elem;
}

function createWixLinkElement(editor, id, url) {
    var elem = new CKEDITOR.dom.element('link', editor.document);
    elem.setAttribute('id', id);
    elem.setAttribute('type', 'text/css');
    elem.setAttribute('rel', 'stylesheet');
    elem.setAttribute('href', url);
    return elem;
}

function getWixCssElement(editor, id) {
    return editor.document.getById(id);
}

function removeWixCssElem(editor, id) {
    var element = getWixCssElement(editor, id);
    if (element) {
        element.remove();
    }
}

function isCSSExist(editor, param) {
    var currentElement = getWixCssElement(editor, param.id);
    return currentElement && _.isEqual(currentElement.getText(), param.value);
}

function isLinkExist(editor, param) {
    var currentElement = getWixCssElement(editor, param.id);
    return currentElement && _.isEqual(currentElement.getAttribute('href'), param.value);
}

var cmdDefinition = {

    /**
     * param:{id, value, isLink}
     *
     */
    exec: function (editor, param) {
        if (!param.force && (isCSSExist(editor, param) || isLinkExist(editor, param))) {
            return;
        }

        removeWixCssElem(editor, param.id);
        var elem;
        if (param.isLink) {
            elem = createWixLinkElement(editor, param.id, param.value);
        } else {
            elem = createWixStyleElement(editor, param.id, param.value);
        }

        var head = editor.document.getHead();
        head.append(elem);
    },
    canUndo: false,
    editorFocus: false
};

export default function () {
    return cmdDefinition;
}
